module.exports = __webpack_public_path__ + "static/media/physical-activity.82163a16.svg";